import { render } from "./Index.vue?vue&type=template&id=fe5ca9bc&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=fe5ca9bc&lang=scss&scoped=true"

import exportComponent from "E:\\work\\me\\mayun\\lxk_admin_manage\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_eee4889a858be1e5640b6fb3f8529091\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe5ca9bc"]])

export default __exports__